import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'service_order';

export default {
  async create(serviceOrderId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/photo/create`);
    return api.post(url, data);
  },
  async update(serviceOrderId, photoId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/photo/${photoId}`);
    return api.patch(url, data);
  },
  async inactivate(serviceOrderId, photoId) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/photo/${photoId}/disable`);
    return api.delete(url);
  }
};
